if (!customElements.get('clawt-review-cards')) {
  customElements.define('clawt-review-cards', class extends HTMLElement {
    connectedCallback() {
      if (this.source) return;
      this.source = this.querySelector('.cr-source');
      this.enhanced = this.querySelector('.cr-enhanced');
      this.rail = this.querySelector('.cr-rail');
      this.dialog = this.querySelector('.cr-dialog');
      this.nativeView = false;
      this.filtersOpen = false;
      this.records = [];
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.querySelector('[data-cr-all]').addEventListener('click', () => this.toggleFilters(), { signal });
      this.querySelector('[data-cr-write]').addEventListener('click', () => this.showNative(true), { signal });
      this.querySelector('[data-cr-return]').addEventListener('click', () => { this.nativeView = false; this.source.hidden = true; this.enhanced.hidden = false; this.querySelector('[data-cr-return]').hidden = true; this.layout(); }, { signal });
      this.querySelector('[data-cr-prev]').addEventListener('click', () => this.slide(-1), { signal });
      this.querySelector('[data-cr-next]').addEventListener('click', () => this.slide(1), { signal });
      this.querySelector('[data-cr-close]').addEventListener('click', () => this.dialog.close(), { signal });
      this.rail.addEventListener('scroll', () => this.updateNavigation(), { signal, passive: true });
      this.rail.addEventListener('pointerdown', event => {
        if (event.pointerType !== 'mouse' || event.button !== 0 || event.target.closest('button,a')) return;
        this.drag = { x: event.clientX, left: this.rail.scrollLeft };
        this.rail.setPointerCapture(event.pointerId);
        this.rail.classList.add('cr-dragging');
      }, { signal });
      this.rail.addEventListener('pointermove', event => {
        if (this.drag) this.rail.scrollLeft = this.drag.left + this.drag.x - event.clientX;
      }, { signal });
      const stop = () => { this.drag = null; this.rail.classList.remove('cr-dragging'); };
      this.rail.addEventListener('pointerup', stop, { signal });
      this.rail.addEventListener('pointercancel', stop, { signal });
      this.rail.addEventListener('lostpointercapture', stop, { signal });
      this.observer = new MutationObserver(() => this.schedule());
      this.observer.observe(this.source, { subtree: true, childList: true, characterData: true });
      this.resize = new ResizeObserver(() => this.scheduleLayout());
      this.resize.observe(this.rail);
      document.fonts?.ready.then(() => { if (this.isConnected) this.scheduleLayout(); });
      this.schedule();
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
      this.resize?.disconnect();
      cancelAnimationFrame(this.frame);
      cancelAnimationFrame(this.layoutFrame);
      this.source = null;
    }
    schedule() {
      cancelAnimationFrame(this.frame);
      this.frame = requestAnimationFrame(() => {
        try { this.sync(); } catch (error) { this.source.hidden = false; this.enhanced.hidden = true; }
      });
    }
    sync() {
      if (this.dataset.enabled !== 'true') return;
      const nodes = Array.from(this.source.querySelectorAll('.jdgm-review-list .jm-review-item'));
      const records = nodes.map(node => {
        const name = node.querySelector('.jm-reviewer-info__name')?.textContent.trim();
        const text = node.querySelector('.jdgm-review-content__body-content')?.textContent.trim();
        const ratingLabel = node.querySelector('.jm-star-rating[aria-label]')?.getAttribute('aria-label') || '';
        const rating = Number.parseFloat(ratingLabel);
        const date = node.querySelector('.jm-reviewer-info__details > .jm-cluster:nth-child(2)')?.textContent.trim() || '';
        const title = node.querySelector('.jm-review-content__title')?.textContent.trim() || '';
        const images = Array.from(node.querySelectorAll('.jm-media-thumbnail-list__thumbnail img')).map(image => ({ src: image.currentSrc || image.src, srcset: image.srcset, alt: image.alt }));
        const reply = node.querySelector('.jm-review-reply')?.textContent.trim() || '';
        return { name, text, rating, ratingLabel, date, title, images, reply, id: node.getAttribute('review-uuid') };
      });
      if (!records.length || nodes.some(node => node.querySelector('video,.jm-video-thumbnail')) || records.some(record => !record.name || !record.text || !(record.rating >= 0 && record.rating <= 5))) {
        this.records = [];
        this.signature = null;
        this.source.hidden = false;
        this.enhanced.hidden = true;
        return;
      }
      const signature = JSON.stringify(records);
      if (signature === this.signature) return;
      this.signature = signature;
      this.records = records;
      const averageNode = this.source.querySelector('.jm-average-rating-display');
      const average = averageNode ? Array.from(averageNode.querySelectorAll('p')).map(node => node.textContent.trim()).filter(Boolean).join(' · ') || averageNode.textContent.trim() : '';
      this.querySelector('.cr-summary').textContent = average || '';
      this.enhanced.hidden = this.nativeView;
      this.source.hidden = !this.filtersOpen;
      this.source.classList.toggle('cr-controls-only',this.filtersOpen);
      if (!this.nativeView) this.layout();
    }
    element(tag, className, text) {
      const node = document.createElement(tag);
      if (className) node.className = className;
      if (text !== undefined) node.textContent = text;
      return node;
    }
    card(record, tall) {
      const article = this.element('article', 'cr-card' + (tall ? ' cr-tall' : ''));
      article.setAttribute('role', 'listitem');
      article.setAttribute('aria-label', record.name + ', ' + record.ratingLabel);
      if (record.images.length) {
        const button = this.element('button', 'cr-photo');
        button.type = 'button';
        button.setAttribute('aria-label', this.dataset.photo);
        const image = this.element('img');
        image.src = record.images[0].src;
        if (record.images[0].srcset) image.srcset = record.images[0].srcset;
        image.sizes = '(max-width:599px) 80vw, 300px';
        image.alt = record.images[0].alt || this.dataset.photo;
        image.loading = 'lazy';
        button.append(image);
        if (record.images.length > 1) button.append(this.element('span', 'cr-photo-count', '+' + (record.images.length - 1)));
        button.addEventListener('click', () => this.openReview(record));
        article.append(button);
      }
      const copy = this.element('div', 'cr-copy');
      const stars = this.element('div', 'cr-stars', '\u2605'.repeat(Math.round(record.rating)) + '\u2606'.repeat(5 - Math.round(record.rating)));
      stars.setAttribute('role', 'img');
      stars.setAttribute('aria-label', record.ratingLabel);
      copy.append(this.element('div', 'cr-person', record.name), this.element('div', 'cr-date', record.date), stars);
      if (record.title) copy.append(this.element('div', 'cr-title', record.title));
      const body = this.element('p', 'cr-text', record.text);
      const more = this.element('button', 'cr-more', this.dataset.readMore);
      more.type = 'button';
      more.hidden = true;
      more.addEventListener('click', () => this.openReview(record));
      copy.append(body, more);
      article.append(copy);
      article.crBody = body;
      article.crMore = more;
      article.crRecord = record;
      return article;
    }
    scheduleLayout() {
      cancelAnimationFrame(this.layoutFrame);
      this.layoutFrame = requestAnimationFrame(() => { if (this.records.length && !this.nativeView) this.layout(); });
    }
    layout(promoted = new Set()) {
      if (!this.rail.clientWidth) return;
      const scroll = this.rail.scrollLeft;
      const fragment = document.createDocumentFragment();
      let pending;
      const limit = Number(this.dataset.shortLimit) || 180;
      this.records.forEach(record => {
        const tall = record.images.length > 0 || record.text.length + record.title.length > limit || promoted.has(record.id);
        if (tall || !pending) {
          const column = this.element('div', 'cr-column');
          column.setAttribute('role', 'presentation');
          fragment.append(column);
          column.append(this.card(record, tall));
          pending = tall ? null : column;
        } else {
          pending.append(this.card(record, false));
          pending = null;
        }
      });
      this.rail.replaceChildren(fragment);
      this.rail.scrollLeft = scroll;
      let changed = false;
      this.rail.querySelectorAll('.cr-card').forEach(card => {
        const overflow = card.crBody.scrollHeight > card.crBody.clientHeight + 2;
        if (overflow && !card.classList.contains('cr-tall')) { promoted.add(card.crRecord.id); changed = true; }
        else card.crMore.hidden = !overflow && !card.crRecord.reply;
      });
      if (changed) this.layout(promoted);
      else this.updateNavigation();
    }
    updateNavigation() {
      const max = this.rail.scrollWidth - this.rail.clientWidth;
      this.querySelector('[data-cr-prev]').disabled = this.rail.scrollLeft <= 2;
      this.querySelector('[data-cr-next]').disabled = this.rail.scrollLeft >= max - 2;
      this.querySelector('.cr-status').textContent = this.dataset.progress.replace('{count}', this.records.length);
    }
    slide(direction) {
      const first = this.rail.firstElementChild;
      if (!first) return;
      const gap = Number.parseFloat(getComputedStyle(this.rail).columnGap) || 16;
      this.rail.scrollBy({ left: direction * (first.getBoundingClientRect().width + gap), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    }
    openReview(record) {
      const content = this.querySelector('.cr-dialog-content');
      content.replaceChildren(this.element('strong', '', record.name), this.element('div', 'cr-stars', '\u2605'.repeat(Math.round(record.rating))), this.element('p', '', record.text));
      if (record.title) content.prepend(this.element('h3', '', record.title));
      record.images.forEach(photo => { const image = this.element('img'); image.src = photo.src; if (photo.srcset) image.srcset = photo.srcset; image.sizes = '640px'; image.alt = photo.alt || this.dataset.photo; content.append(image); });
      if (record.reply) content.append(this.element('p', '', record.reply));
      this.dialog.showModal();
    }
    showNative(write) {
      if (!write) return this.toggleFilters();
      this.source.hidden = false;
      this.source.classList.add('cr-controls-only');
      if (write) {
        const button = Array.from(this.source.querySelectorAll('button,a')).find(node => /write a review/i.test(node.textContent));
        button?.click();
      }
    }
    toggleFilters() {
      this.filtersOpen = !this.filtersOpen;
      this.source.hidden = !this.filtersOpen;
      this.source.classList.add('cr-controls-only');
      this.enhanced.hidden = false;
      this.querySelector('[data-cr-all]').setAttribute('aria-expanded',String(this.filtersOpen));
      this.querySelector('[data-cr-return]').hidden = true;
      this.layout();
    }
  });
}
